<tgrid-report-header hideState [report]="report()" (export)="exportAsCsv()"></tgrid-report-header>

<div class="state-metrics">
  <div class="metric-card total-customers">
    <span class="lg">Total Customers</span>
    <div class="metric-value display-value xl">
      {{ stateMetric()?.totalCustomers | number }}
    </div>
  </div>
  <div class="metric-card covered-customers">
    <span class="lg">Covered Customers</span>
    <div class="metric-value display-value xl">
      {{ stateMetric()?.coveredCustomers | number }}
    </div>
  </div>
  <div class="metric-card percent-covered">
    <span class="lg">Percent Coverage</span>
    <div class="metric-value display-value xl">
      {{ stateMetric()?.percentage | number : '1.0-2' }}%
    </div>
  </div>
</div>

<div class="county-metrics">
  <div class="filter-bar">
    <h3>Coverage By County</h3>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <vulcan-icon class="filter-prefix" matPrefix icon="funnel-simple"></vulcan-icon>
      <input matInput placeholder="Type to filter by county..." [formControl]="countyNameControl">
    </mat-form-field>
  </div>
  <div>

    <table mat-table matSort [dataSource]="dataSource" matSortActive="county" matSortDirection="asc"
           matSortDisableClear>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>

      <ng-container matColumnDef="coveredCustomers">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Covered Customers</th>
        <td mat-cell *matCellDef="let element"> {{ (element.coveredCustomers | number) || 'N/A' }}</td>
      </ng-container>

      <ng-container matColumnDef="totalCustomers">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Total Customers</th>
        <td mat-cell *matCellDef="let element"> {{ (element.totalCustomers | number) || 'N/A' }}</td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> State</th>
        <td mat-cell *matCellDef="let element"> {{ element.state }}</td>
      </ng-container>

      <ng-container matColumnDef="county">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> County</th>
        <td mat-cell *matCellDef="let element"> {{ element.county }}</td>
      </ng-container>

      <ng-container matColumnDef="year">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Year</th>
        <td mat-cell *matCellDef="let element"> {{ element.year || 'N/A' }}</td>
      </ng-container>

      <ng-container matColumnDef="percentage">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> Percentage</th>


        <td mat-cell *matCellDef="let element">
          @if (!element.percentage) {
            <span> N/A </span>
          } @else {
            {{ (element.percentage | number : '1.0-2') }}%
          }
        </td>

      </ng-container>

    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 75, 100]" showFirstLastButtons
                   aria-label="Select coverage page"></mat-paginator>
    @if (report()) {
      <a class="attribution-link" target="_blank"
         [href]="report().attributionUrl">{{ report().attributionTitle || 'N/A' }}</a>
    }
  </div>


</div>
